import { createContext } from "react";
import { useInfiniteNpcs } from "./Npc.state";

export const NpcContext = createContext();
export const NpcContextProvider = ({ children }) => {
    const npcs = useInfiniteNpcs();

    return (
        <NpcContext.Provider value={{ npcs }}>
            { children }
        </NpcContext.Provider>
    )
}